const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_CONTACT_IMAGES':
      return action.contactImages;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/contactImages.js